import { css } from '@emotion/react'
import Base from 'gatsby-theme-marketplace-base/src/components/ProductList/Card/Base'
import mediaQueries from '../../../layout/media-queries'

const overrideCss = css`
  ${mediaQueries.smallScreen(-150)} {
    width: calc(50% - 32px);
    margin: 0 16px 32px 16px;
  }

  ${mediaQueries.largeScreen(-300)} {
    width: calc(33.3% - 32px);
    margin: 0 16px 32px 16px;
  }
`

export default (props) => <Base {...props} css={overrideCss} />
